export const DOMAIN_TAGS = {
  "Web Dev":     ["webdev", "frontend", "html", "css", "javascript"],
  "AI / ML":     ["ai", "machinelearning", "python", "data"],
  "App Dev":     ["mobile", "android", "ios", "reactnative"],
  "Design":      ["design", "ui", "ux", "figma", "creative"],
  "Game Dev":    ["gamedev", "unity", "indiegame", "fun"],
  "Data":        ["data", "analytics", "sql", "visualization"],
  "DevOps":      ["devops", "cloud", "docker", "aws"],
  "Open Source": ["opensource", "community", "collaboration"],
  "Fun / Other": ["fun", "creative", "vibe", "nocode"]
};

export const DOMAINS = Object.keys(DOMAIN_TAGS);
